import { t } from '@lingui/macro'
import { isAuthorized } from 'helpers'

export const getStaffRoutes = (userRoles, navigate) => {
  const has_staffplanner = isAuthorized(userRoles, ['staff_planner', 'admin'])
  const has_eventplanner = isAuthorized(userRoles, ['event_planner', 'admin'])
  const has_checkin = isAuthorized(userRoles, ['check_in', 'admin'])
  const has_salary = isAuthorized(userRoles, ['salary', 'admin'])
  const has_settings = isAuthorized(userRoles, [
    'admin',
    'staff_planner',
    'event_planner',
    'room_planner'
  ])

  return [
    {
      path: '/staff/dashboard',
      label: t`Dashboard`,
      onClick: path => navigate(path),
      disabled: !has_staffplanner
    },
    {
      path: '/staff/calendar/today/week',
      label: t`Calendar`,
      onClick: path => window.location.assign(path),
      disabled: !has_staffplanner
    },
    {
      path: '/staff/shiftlist/shifts/1',
      label: t`Shifts`,
      onClick: path => navigate(path),
      disabled: !has_staffplanner
    },
    {
      path: '/staff/staff',
      label: t`Staff`,
      onClick: path => navigate(path),
      disabled: !has_staffplanner
    },
    {
      path: '/staff/messages',
      label: t`Messages`,
      onClick: path => navigate(path),
      disabled: !has_staffplanner
    },
    {
      path: '/staff/salary',
      label: t`Salary`,
      onClick: path => window.location.assign(path),
      disabled: !has_salary || !has_staffplanner
    },
    {
      path: '/staff/checkin',
      label: 'Check-in',
      onClick: path => navigate(path),
      disabled: !has_checkin
    },
    {
      path: '/staff/statistics',
      label: t`Statistics`,
      onClick: path => navigate(path),
      disabled: !has_staffplanner
    },
    {
      path: '/staff/guestlists/1',
      label: t`Guest lists`,
      onClick: path => navigate(path),
      disabled: !has_eventplanner
    },
    {
      path: '/staff/setup',
      label: t`Setup`,
      onClick: path => navigate(path),
      disabled: !has_staffplanner
    },
    {
      path: '/staff/settings',
      label: t`Settings`,
      onClick: path => navigate(path),
      disabled: !has_settings || !has_staffplanner
    }
  ]
}
